import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { useSelector } from "react-redux";

import * as SearchSelectors from "@/redux/modules/value/search/search.selectors";
import { SearchComponent } from "@/utils/search/types/searchComponent";

import { useSearchResultsContext } from "../../context/searchResults.context";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    const { showResults } = useSearchResultsContext();

    const hasResultComponents = useSelector(
        SearchSelectors.hasAnyComponents([
            SearchComponent.PRODUCT_NUMBER_OF_HITS,
            SearchComponent.CONTENT_NUMBER_OF_HITS
        ])
    );

    if (!showResults || !hasResultComponents) {
        return null;
    }

    return <>{children}</>;
};

export { Base };
